import SensorsIntegrationsGridComponent from './component/IntegrationsGridComponent';
import { WEB_COMPONENT_SENSORS_INTEGRATIONS_GRID } from '../../webcomponents.constants';

export default SensorsIntegrationsGridComponent;

window.customElements.define(WEB_COMPONENT_SENSORS_INTEGRATIONS_GRID, SensorsIntegrationsGridComponent);
